import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import ProofStrip from '../components/Home/ProofStrip';
import ComparisonHub from '../components/Home/ComparisonHub';
import SectionDivider from '../components/Home/SectionDivider';
import PathwaysSection from '../components/Home/PathwaysSection';
import ContentClusters from '../components/Home/ContentClusters';
import TrustSection from '../components/Home/TrustSection';
import ClosingCTA from '../components/Home/ClosingCTA';
import NewsletterSection from '../components/Layout/NewsletterSection';

const FadeUp = ({ children }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (navigator.webdriver) return;
    const el = ref.current;
    if (!el) return;
    if (el.getBoundingClientRect().top < window.innerHeight) return;

    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out';

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return <Box ref={ref}>{children}</Box>;
};

const HomeBelowFold = () => (
  <>
    <FadeUp><ProofStrip /></FadeUp>
    <FadeUp><PathwaysSection /></FadeUp>
    <FadeUp><ComparisonHub /></FadeUp>
    <SectionDivider from="#FFFFFF" to="#F7F9FC" />
    <FadeUp><ContentClusters /></FadeUp>
    <SectionDivider from="#F7F9FC" to="#F7F9FC" />
    <FadeUp><TrustSection /></FadeUp>
    <FadeUp><ClosingCTA /></FadeUp>
    <NewsletterSection />
  </>
);

export default HomeBelowFold;
